import allData from '@/data/allData'

export default function () {
  const { locale } = useI18n()

  const getItems = (elements: Array<string>) => {
    let items = {}

    elements.forEach((el) => {
      const singleElement = allData[locale.value][el]
      items = Object.assign(items, singleElement)
    })
    return items
  }

  return {
    getItems,
  }
}
